<template>
  <div class="analytics-total">
    <div class="card">
      <label class="title">{{ metric }}</label>
      <el-tooltip class="ml-x1" v-if="tooltip" placement="top" :content="tooltip"
        ><i class="mr-x2 mdi mdi-help-circle"></i
      ></el-tooltip>
      <slot name="tooltip-content" />
      <div class="value mt-x2" :class="{ 'text-success': is_value_up, 'text-danger': is_value_down }">
        {{ display_value }}
      </div>
      <div
        class="mt-x2"
        v-if="notationText"
        :class="{ 'notation-highlight-text': notationText === '最終データ取得待ち' }"
      >
        {{ notationText }}
      </div>
      <div class="mt-x4" v-if="isTikTok"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.value {
  font-size: 32px;
}

.notation-highlight-text {
  color: #26a69a;
}
</style>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { formatNumber } from '@/client/filters/filters'

export default defineComponent({
  props: {
    metric: String,
    value: {
      type: Number as PropType<number | null>,
      default: 0
    },
    tooltip: {
      type: String,
      default: null
    },
    isUpDown: {
      type: Boolean,
      default: false
    },
    notationText: {
      type: String,
      default: null
    },
    isTikTok: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    is_value_up() {
      return this.isUpDown && this.value !== null && this.value > 0
    },

    is_value_down() {
      return this.isUpDown && this.value !== null && this.value < 0
    },

    display_value() {
      if (this.is_value_up) {
        return `+${formatNumber(this.value ?? 0)}`
      }

      // formatNumber は Number() で変換するので、null は 0 と同じ表示になる
      return formatNumber(this.value ?? 0)
    }
  }
})
</script>
